/* eslint-disable class-methods-use-this */
import CustomerDto from '../dtos/customer-dto';
import { Country } from '../models/country';
import Customer from '../models/customer';
import { Ubigeo } from '../models/ubigeo';

export default class CustomerMapping {
  formatGetCustomerResponse(data: CustomerDto): Customer {
    return {
      id: data.identificadorCliente,
      ubigeo: data.ubigeo,
      names: data.nombres,
      gender: data.genero,
      verified: data.verificado,
      requestBirthDate: data.solicitarFechaNacimiento,
      hasComeWithConsent: data.flagConsentimiento,
    };
  }

  formatPatchCustomerRequest(data: Customer): CustomerDto {
    return {
      nombres: data.names,
      apellidoPaterno: data.firstSurname,
      apellidoMaterno: data.lastSurname,
      correo: data.email,
      numeroCelular: data.mobile,
      direccion: data.address,
      ubigeo: data.ubigeo,
      fechaNacimiento: data.birthDate,
      genero: data.gender,
      nacionalidad: data.nationality,
      identificadorCliente: data.id,
    };
  }

  formatCountriesResponse(data: any): Country[] {
    return data.map((item: any) => {
      return {
        code: item.codigo,
        name: item.nombre,
      };
    });
  }

  formatUbigeoResponse(data: any): Ubigeo[] {
    return data.map((item: any) => {
      return {
        ubigeo: item.ubigeo,
        city: item.ciudad,
      };
    });
  }
}
